var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7991 1.85449H19.8914L13.1355 9.57603L21.0833 20.0833H14.8603L9.98616 13.7107L4.40908 20.0833H1.31486L8.54094 11.8242L0.916626 1.85449H7.29764L11.7034 7.6793L16.7991 1.85449ZM15.7137 18.2324H17.4272L6.36657 3.6082H4.5278L15.7137 18.2324Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterImage);
export default __webpack_public_path__ + "static/media/twitter-image.12b75995534933661594bbe26ee01108.svg";
export { ForwardRef as ReactComponent };